import { styled } from 'react-ui-kit-exante';

export const StyledTooltipWrapper = styled('div')`
  white-space: break-spaces;
`;
